import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { useGetCollectionTicketClaims } from '@/api/trafikportalen';
import type { CollectionTicketClaimDTO } from '@/api/trafikportalen';

export const hasActiveOrScheduledClaim = (
  claims: CollectionTicketClaimDTO[] | undefined,
): boolean => {
  if (!claims || claims.length === 0) return false;

  const now = DateTime.now();

  return claims.some((claim) => {
    const from = claim.valid_from ? DateTime.fromISO(claim.valid_from) : null;
    const to = claim.valid_to ? DateTime.fromISO(claim.valid_to) : null;

    const isUpcoming = from && from > now;
    const isActive = !(to && to < now) && !isUpcoming;

    return isUpcoming || isActive;
  });
};

export const useCollectionClaimWarning = (
  collectionId: string | null | undefined,
) => {
  const { data: ticketClaims, isLoading } = useGetCollectionTicketClaims(
    collectionId ?? '',
    {
      query: { enabled: !!collectionId },
    },
  );

  const hasWarning = useMemo(() => {
    if (!collectionId || isLoading) return false;
    return !hasActiveOrScheduledClaim(ticketClaims);
  }, [collectionId, isLoading, ticketClaims]);

  return { hasWarning, isLoading };
};
